import { Api } from '@/munio/api/base'
import {
  CompanyBasicResourceDto,
  ResourceResponse,
  UserImportRecordResourceDto,
  UserImportResourceDto,
} from '@/munio/api/data'

type FileImportResponse = ResourceResponse<UserImportResourceDto> & {
  columns: Record<string, string> & {
    email: string
  }
}

type ProcessEvents = {
  started: (batch: UserImportResourceDto) => void
  progress: (record: UserImportRecordResourceDto) => void
  completed: (batch: UserImportResourceDto) => void
}

export default class Import extends Api {
  get users() {
    return new UserImport()
  }
}

class UserImport extends Api {
  emails(emails: string[], batch?: string) {
    return this.$post<ResourceResponse<UserImportResourceDto>>(this.$route('api.web.admin.import.users'), {
      emails,
      batch,
    })
  }

  file(file: File, delimiter?: string, batch?: string) {
    return this.$post<FileImportResponse>(
      this.$route('api.web.admin.import.users'),
      { file, delimiter, batch },
      { 'Content-Type': 'multipart/form-data' },
    )
  }

  batch(batch: string) {
    return new Batch(batch)
  }
}

class Batch extends Api<{ batch: string }> {
  constructor(batch: string) {
    super({ batch })
  }

  get() {
    return this.$get<ResourceResponse<UserImportResourceDto>>(this.$route('api.web.admin.import.users.batch'))
  }

  update(company: Partial<CompanyBasicResourceDto>, relationship: number, mapping?: (string | null)[]) {
    const url = this.$route('api.web.admin.import.users.batch.update')

    return this.$post<ResourceResponse<UserImportResourceDto>>(url, {
      company,
      relationship,
      mapping,
    })
  }

  process(events: ProcessEvents) {
    return this.$sse(this.$route('api.web.admin.import.users.batch.process'), events)
  }

  delete() {
    return this.$delete<null>('api.web.admin.import.users.batch.delete')
  }
}
